(function(){
  if (window.__dhlpEventsBound) return;
  window.__dhlpEventsBound = true;

  function pushEvent(name, params){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, params || {}));
  }

  document.addEventListener('click', function(e){
    var el = e.target.closest('[data-dhlp-event]');
    if (!el) return;

    pushEvent(el.getAttribute('data-dhlp-event'), {
      dhlp_section: el.getAttribute('data-dhlp-section') || '',
      dhlp_product: el.getAttribute('data-dhlp-product') || '',
      dhlp_label: el.textContent.trim().slice(0, 80)
    });
  });
})();
